import React, { FC } from 'react';
import { BasicSpinner } from '@grow-components/Spinners/BasicSpinner';

import styles from './OverlaySpinner.module.scss';

export const OverlaySpinner: FC = () => (
  <div className={styles.container}>
    <BasicSpinner />
  </div>
);